'use client';

import { useEffect, useRef, useState } from 'react';
import styles from './ingredient-list-stagger.module.css';

export function IngredientListStagger({ children }: { children: React.ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  const [revealed, setRevealed] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => { if (e.isIntersecting) setRevealed(true); });
      },
      { threshold: 0.15 },
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <div
      ref={ref}
      className={`${styles.staggerHost} ${revealed ? styles.revealed : ''}`}
    >
      {children}
    </div>
  );
}
